import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { Form, Input, Button, Spin, DatePicker } from "antd";
import {
  MISSATGE_CAMP_OBLIGATORI,
  MISSATGE_BAIXA_INDIVIDU_ERROR,
  MISSATGE_BAIXA_INDIVIDU_OK,
  MISSATGE_BAIXA_INDIVIDU_TITOL,
  MISSATGE_SPIN_BAIXA_INDIVIDU,
  TITOL_BAIXA_INDIVIDU
} from "../../constantsFormularis";
import styles from "./IndividuFormulariDonarBaixa.module.css";
import { NotificacioExit } from "../Notification";
import { fetchDonarBaixaIndretIndividu } from "../../actions/consultesServidor";
import * as rutes from "../../routes";
import { getDadesIndividu } from "../../reducers";
import { setTitolApartat, errorConsultaServidor } from "../../actions";
import {
  MASCARA_DDMMYYYY,
  MASCARA_YYYYMMDD,
  convertirTextAMomentLocal,
  formatStringDate
} from "../../utils/dates";
import { rutaIndividus } from "../../routes";

class IndividuFormulariDonarBaixa extends Component {
  state = {
    canviEnCurs: false
  };

  componentDidMount() {
    this.props.setTitolApartat(TITOL_BAIXA_INDIVIDU);
  }

  setCanviEnCurs = value => {
    this.setState({ canviEnCurs: value });
  };

  getNomObservador = individu => {
    return individu ? individu.nomObservador : "";
  };

  getDataAlta = individu => {
    return individu ? individu.indretIndividuDataAlta : "";
  };

  getDescripcioIndividu = individu => {
    return individu ? individu.descripcio : "";
  };

  getNomIndret = individu => {
    return individu ? individu.nomIndret : "";
  };

  getDataAltaValidator = data => {
    let dataAltaMenysUnDia = new Date(data);
    dataAltaMenysUnDia.setDate(dataAltaMenysUnDia.getDate() + 1);
    return formatStringDate(dataAltaMenysUnDia, MASCARA_YYYYMMDD);
  };

  handleCanvi = e => {
    this.setCanviEnCurs(true);
    e.preventDefault();
    const { form, dadesIndividu, history } = this.props;
    const idIndividu = dadesIndividu.id;
    const idIndret = dadesIndividu.idIndret;
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const dataSeleccionada = convertirTextAMomentLocal(
          values.dataSeleccionada
        ).format(MASCARA_DDMMYYYY);

        fetchDonarBaixaIndretIndividu(
          idIndividu,
          idIndret,
          dataSeleccionada,
          values.motiubaixa
        ).then(
          dadesResultat => {
            form.resetFields();
            this.setCanviEnCurs(false);
            dadesResultat && dadesResultat.message
              ? this.props.errorConsultaServidor(
                  dadesResultat.titol,
                  dadesResultat.message
                )
              : dadesResultat
                ? NotificacioExit(
                    MISSATGE_BAIXA_INDIVIDU_TITOL,
                    MISSATGE_BAIXA_INDIVIDU_OK
                  )
                : this.props.errorConsultaServidor(
                    MISSATGE_BAIXA_INDIVIDU_TITOL,
                    MISSATGE_BAIXA_INDIVIDU_ERROR
                  );
            history.push({
              pathname: rutaIndividus
            });
          },
          error => {
            this.setCanviEnCurs(false);
            this.props.errorConsultaServidor(
              error,
              error.titol ? error.titol : MISSATGE_BAIXA_INDIVIDU_TITOL
            );
          }
        );
      }
      this.setCanviEnCurs(false);
    });
  };

  render() {
    const { form, dadesIndividu } = this.props;
    const { getFieldDecorator } = form;
    const nomObservador = this.getNomObservador(dadesIndividu);
    const nomIndret = this.getNomIndret(dadesIndividu);
    const descripcioIndividu = this.getDescripcioIndividu(dadesIndividu);
    const altaIndividu = formatStringDate(
      this.getDataAlta(dadesIndividu),
      MASCARA_DDMMYYYY
    );
    const { TextArea } = Input;

    return (
      <Spin
        spinning={this.state.canviEnCurs}
        tip={MISSATGE_SPIN_BAIXA_INDIVIDU}
        delay={0}
      >
        <div>
          <div className={styles.baixa_form}>
            <div>
              <span className={styles.campTitol}>{"Observador: "}</span>
              {nomObservador}
            </div>
            <div>
              <span className={styles.campTitol}>{"Indret: "}</span>
              {nomIndret}
            </div>
            <div>
              <span className={styles.campTitol}>{"Individu: "}</span>
              {descripcioIndividu}
            </div>
            <div>
              <span className={styles.campTitol}>{"Data Alta: "}</span>
              {altaIndividu}
            </div>

            <Form layout="vertical" onSubmit={this.handleCanvi}>
              <Form.Item
                label="Seleccionar la data de baixa"
                className={styles.label}
              >
                {getFieldDecorator("dataSeleccionada", {
                  rules: [
                    {
                      type: "object",
                      required: true,
                      message: "Aquest camp és obligatori"
                    }
                  ]
                })(
                  <DatePicker
                    placeholder="Seleccionar data"
                    format={MASCARA_DDMMYYYY}
                    disabledDate={d =>
                      !d ||
                      d.isBefore(
                        this.getDataAltaValidator(
                          this.getDataAlta(dadesIndividu)
                        )
                      )}
                  />
                )}
              </Form.Item>
              <Form.Item label="Motiu baixa" className={styles.label}>
                {getFieldDecorator("motiubaixa", {
                  rules: [
                    {
                      required: true,
                      message: MISSATGE_CAMP_OBLIGATORI
                    }
                  ]
                })(<TextArea rows={4} />)}
              </Form.Item>

              <Link
                className={styles.botoTornar}
                to={{
                  pathname: rutes.rutaDetallIndividu,
                  query: { render: false }
                }}
              >
                <Button icon="left">Tornar</Button>
              </Link>

              <Button type="primary" htmlType="submit">
                Guardar
              </Button>

              <Form.Item />
            </Form>
          </div>
        </div>
      </Spin>
    );
  }
}

IndividuFormulariDonarBaixa.propTypes = {
  dadesIndividu: PropTypes.object,
  setTitolApartat: PropTypes.func.isRequired,
  errorConsultaServidor: PropTypes.func.isRequired,
  history: PropTypes.object
};

const mapStateToProps = state => {
  return {
    dadesIndividu: getDadesIndividu(state)
  };
};

const mapDispatchToProps = {
  setTitolApartat,
  errorConsultaServidor
};

const WrappedNormalBaixaForm = Form.create({ name: "baixa_individu" })(
  IndividuFormulariDonarBaixa
);

export default connect(mapStateToProps, mapDispatchToProps)(
  WrappedNormalBaixaForm
);
